export default __webpack_public_path__ + "static/media/gethair.5d9b71ca.png";